import { loadStripe } from '@stripe/stripe-js';

import settings from './settings';

const stripe = loadStripe(settings.stripe.publishableKey);

export default stripe;
